// Required dependencies
import 'jquery';
import 'bootstrap';

// Assets
// These assets are extracted to [id].bundle.css using MiniCssExtractPlugin, see more on webpack.config.js
//import 'bootstrap/dist/css/bootstrap.css';
import './theme/style.css';

// UI tweaks
//import './ui/naja';